import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ATTACHMENT_UPLOAD_STATUS } from '../constants/attachments-upload-statue.enum';
import { TuwaiqConfig } from '../constants/tuwaiq.config';

@Injectable({
    providedIn: 'root'
})
export class AttachmentsService {
    onAddAttachment = new Subject<any>();
    onAttachmentUpload = new Subject<any>();

    constructor() {}

    getListOfAttachmentsUploadedToObjStore(attachmentList) {
        return attachmentList.filter(i => i.uploadStatus === ATTACHMENT_UPLOAD_STATUS.UPLOADED);
    }

    isAttachmentListValid(attachmentList) {
        //NOTE: in order to be valid, there needs to be:
        // 1. new no attachment that have not been uploaded &&
        // 2. No attachments in the uploading process &&
        // 3. attachments with errors within th list
        // 4. attachments with maximum allowed length
        const hasError = attachmentList.some(i => i.hasError === true);
        const isUploading = attachmentList.some(i => i.uploadStatus === ATTACHMENT_UPLOAD_STATUS.UPLOADING);
        const isNew = attachmentList.some(i => i.uploadStatus === ATTACHMENT_UPLOAD_STATUS.NEW);
        const exceedsMaxAllowedLength = attachmentList.length > TuwaiqConfig.MAX_ATTACHMENT_UPLOAD_NUMBER ? true : false;

        return !hasError && !isUploading && !isNew && !exceedsMaxAllowedLength;
    }
}
